export default __webpack_public_path__ + "static/media/zona.9eaed3d4.svg";